gsap.registerPlugin(ScrollTrigger);

let smoother;
let mm = gsap.matchMedia();
let headerOffset;
let lastScrollTop = 0;

// Desktop ScrollSmoother
mm.add('(min-width: 1024px)', () => {
    smoother = ScrollSmoother.create({
        smooth: 0.7,
        effects: true,
        smoothTouch: false,
        normalizeScroll: true,
    });
    window.smoother = smoother;
    headerOffset = '-101%';
});

// Mobile ScrollSmoother - lighter configuration
mm.add('(max-width: 1023px)', () => {
    smoother = ScrollSmoother.create({
        smooth: 0.99,
        effects: true,
        smoothTouch: false, // Keep native touch scrolling
    });
    window.smoother = smoother;
    headerOffset = '-115%';
});

// Fade-up animation with stagger
gsap.utils.toArray('.fade-up').forEach((element) => {
    gsap.from(element, {
        y: 60,
        opacity: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
            trigger: element,
            start: 'top 85%',
            toggleActions: 'play none none none',
        },
    });
});

// Staggered fade-up for grouped elements
gsap.utils.toArray('.fade-up-group').forEach((group) => {
    const elements = group.querySelectorAll('.fade-up-item');
    gsap.from(elements, {
        y: 60,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        ease: 'power3.out',
        scrollTrigger: {
            trigger: group,
            start: 'top 85%',
            toggleActions: 'play none none none',
        },
    });
});

// Split text animation - fade from left to right
gsap.utils.toArray('.split').forEach((element) => {
    const text = element.textContent;
    const words = text.split(' ');

    element.innerHTML = words
        .map((word) => {
            const chars = word.split('');
            return `<span class="word">${chars.map((char) => `<span class="char">${char}</span>`).join('')}</span>`;
        })
        .join(' ');

    const chars = element.querySelectorAll('.char');

    gsap.from(chars, {
        opacity: 0,
        x: -20,
        duration: 0.7,
        stagger: 0.02,
        ease: 'power2.inOut',
        scrollTrigger: {
            trigger: element,
            start: 'top 85%',
            toggleActions: 'play none none none',
        },
    });
});

// Accordion functionality
document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', function () {
        const accordion = this.closest('.accordion-item');
        const content = accordion.querySelector('.accordion-content');
        const isOpen = accordion.classList.contains('accordion-open');

        // Close all other accordions (optional - remove these lines for multi-open)
        document.querySelectorAll('.accordion-item').forEach((item) => {
            if (item !== accordion && item.classList.contains('accordion-open')) {
                item.classList.remove('accordion-open');
                const otherContent = item.querySelector('.accordion-content');
                gsap.to(otherContent, {
                    height: 0,
                    duration: 0.4,
                    ease: 'power2.inOut',
                });
            }
        });

        // Toggle current accordion
        if (isOpen) {
            accordion.classList.remove('accordion-open');
            gsap.to(content, {
                height: 0,
                duration: 0.4,
                ease: 'power2.inOut',
            });
        } else {
            accordion.classList.add('accordion-open');
            const autoHeight = content.scrollHeight;
            gsap.fromTo(
                content,
                { height: 0 },
                {
                    height: autoHeight,
                    duration: 0.4,
                    ease: 'power2.inOut',
                }
            );
        }
    });
});

// Open first accordion by default
const firstAccordion = document.querySelector('.accordion-item');
if (firstAccordion) {
    const firstContent = firstAccordion.querySelector('.accordion-content');
    firstAccordion.classList.add('accordion-open');
    gsap.set(firstContent, { height: 'auto' });
}

// Age-gate validation logic
function initAgeGate() {
    const ageGate = document.querySelector('[data-age-gate]');
    const form = document.querySelector('[data-age-gate-form]');
    const submitButton = document.querySelector('[data-age-gate-submit]');
    const declineButton = document.querySelector('[data-age-gate-decline]');
    const errorElement = document.querySelector('[data-age-gate-error]');

    if (!ageGate || !form) return;

    // Check if already validated via cookie
    if (typeof Cookies !== 'undefined' && Cookies.get('ageGateValidated') === 'true') {
        ageGate.style.display = 'none';
        document.body.classList.remove('age-gate-active');
        if (typeof smoother !== 'undefined' && smoother) smoother.paused(false);
        return;
    }

    // Show age-gate if not validated - jQuery fade in
    $(ageGate).fadeIn(500);
    document.body.classList.add('age-gate-active');
    if (typeof smoother !== 'undefined' && smoother) smoother.paused(true);

    // Handle "I'm over 19+" button submission
    form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Store in cookie to remember the validation (30 days)
        if (typeof Cookies !== 'undefined') {
            Cookies.set('ageGateValidated', 'true', { expires: 30 });
        }

        // Fade out age gate
        $(ageGate).fadeOut(500, function () {
            document.body.classList.remove('age-gate-active');
            if (typeof smoother !== 'undefined' && smoother) smoother.paused(false);
        });
    });

    // Handle "I'm under 19" button click
    if (declineButton) {
        declineButton.addEventListener('click', function (e) {
            e.preventDefault();
            showError('You must be 19 or older to enter this site.');

            // Optional: Redirect to another page after a delay
            // setTimeout(function() {
            //     window.location.href = 'https://www.responsibility.org/';
            // }, 2000);
        });
    }

    function showError(message) {
        if (errorElement) {
            errorElement.textContent = message;
            $(errorElement).addClass('error-active');
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    initAgeGate();
});

// Observer for menu drawer - pause smoother when menu is open.
// V3.0 (Oct 2026): on touch screens the smoother is left running. Pausing it blocks finger
// scrolling inside the drawer, so a drag through a long submenu (Shop Whisky) registers as a tap
// on the first link touched. Dawn already locks the page behind the open drawer on phones and
// tablets (overflow-hidden-tablet on body), so nothing behind the menu moves.
const isTouchScreen = window.matchMedia('(hover: none), (pointer: coarse)').matches;
const menuDrawerSummary = document.querySelector('.header__icon--menu');
if (menuDrawerSummary && smoother) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                const isExpanded = menuDrawerSummary.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                    if (!isTouchScreen) smoother.paused(true);
                    document.body.classList.add('no-scroll');
                } else {
                    if (!isTouchScreen) smoother.paused(false);
                    document.body.classList.remove('no-scroll');
                }
            }
        });
    });

    observer.observe(menuDrawerSummary, {
        attributes: true,
        attributeFilter: ['aria-expanded'],
    });
}

if ($('.product-single').length > 0) {
    const stickyChild = $('.product-image');
    const stickyParent = $('.product__media-wrapper');

    // Pin the sticky child using GSAP ScrollTrigger
    const stickyTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: stickyParent,
            start: 'top 20%',
            end: () => {
                const parentHeight = stickyParent.outerHeight();
                const childHeight = stickyChild.outerHeight();
                return `+=${parentHeight - childHeight}`;
            },
            pin: stickyChild,
            pinSpacing: false,
            scrub: true,
        },
    });
}

const navToggle = document.querySelector('.nav-toggle');
const navDrawer = document.querySelector('.nav-drawer');
const navInner = document.querySelector('.nav-drawer-inner');
const body = $('body');

function openNavDrawer() {
    $(navToggle).addClass('open');
    $(body).addClass('no-scroll');

    $(navDrawer).fadeIn(150, function () {
        $(navDrawer).addClass('open');
    });
    setTimeout(() => {
        $(navInner).addClass('open');
    }, 10);

    if (smoother) {
        smoother.paused(true);
    }
}

function closeNavDrawer() {
    $(navToggle).removeClass('open');
    $(body).removeClass('no-scroll');

    $(navDrawer).fadeOut(150, function () {
        $(navDrawer).removeClass('open');
    });

    setTimeout(() => {
        $(navInner).removeClass('open');
    }, 10);

    if (smoother) {
        smoother.paused(false);
    }
}

if (navToggle && navDrawer) {
    navToggle.addEventListener('click', function () {
        const isOpen = this.classList.contains('open');

        if (isOpen) {
            closeNavDrawer();
        } else {
            openNavDrawer();
        }
    });

    // Close drawer when clicking outside nav-inner
    navDrawer.addEventListener('click', function (event) {
        if (!navInner.contains(event.target) && navToggle.classList.contains('open')) {
            closeNavDrawer();
        }
    });
}

$('.sub-menu-toggle').click(function () {
    $(this).toggleClass('open');
    $(this).next('.sub-menu').toggleClass('open');
    // slide up down
    $(this).next('.sub-menu').slideToggle(150);
});

// Anchor link smooth scrolling with ScrollSmoother
document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        const url = new URL(href, window.location.href);

        // Check if link is on the same page (same pathname)
        if (url.pathname === window.location.pathname && url.hash) {
            const hash = url.hash;

            // Ignore empty hash or just "#"
            if (hash === '#' || hash === '') return;

            const targetElement = document.querySelector(hash);

            if (targetElement && smoother) {
                e.preventDefault();
                smoother.scrollTo(targetElement, true, 'top top');
            }
        }
    });
});

// Scroll to hash on page load
window.addEventListener('load', function () {
    const hash = window.location.hash;

    if (hash && smoother) {
        const targetElement = document.querySelector(hash);

        if (targetElement) {
            // Small delay to ensure smoother is fully initialized
            setTimeout(() => {
                smoother.scrollTo(targetElement, true, 'top top');
            }, 100);
        }
    }
});
